'use client';

import { useEffect } from 'react';

export type QualtricsLoaderProps = {
	enabled?: boolean;
	interceptId?: string;
};

const QualtricsLoader = ({ enabled = false, interceptId }: QualtricsLoaderProps) => {
	useEffect(() => {
		if (!enabled || !interceptId || typeof window === 'undefined') {
			return;
		}

		const win = window as typeof window & { FS?: Record<string, unknown> };

		if (!win.FS) {
			win.FS = {};
		}

		// Mirror checkout by exposing the active intercept id via the FS namespace.
		(win.FS as Record<string, unknown>)['QUALTRICS_INTERCEPT_ID'] = interceptId;
	}, [enabled, interceptId]);

	return null;
};

export default QualtricsLoader;
